<template>
  <div v-if="loaded"
       class="million-read-invite"
  >
    <div class="million-read-invite-banner-container">
      <ym-img class="million-read-invite-banner"
              :src="require('@/assets/img/million_read/invite/banner.png')"
      />
      <ym-img class="million-read-invite-rule-btn"
              :src="require('@/assets/img/million_read/invite/rule.png')"
              @click="handleRuleDetail"
              v-ym-report:COIN_INVITE_RULE_CLICK=""
      />
    </div>
    <div class="million-read-invite-join-activity">
      <ym-img class="million-read-invite-join-activity-bg"
              :src="require('@/assets/img/million_read/invite/join_bg.png')"
      />
      <ym-img v-if="inAppWebView"
              class="million-read-invite-join-activity-join-btn"
              :src="require('@/assets/img/million_read/invite/join_btn.gif')"
              v-ym-report:COIN_INVITE_INVITE_CLICK=""
              @click="handleClickInvite"
      />
      <ym-img v-else
              class="million-read-invite-join-activity-join-btn"
              :src="require('@/assets/img/million_read/invite/web_invite.gif')"
              v-ym-report:COIN_INVITE_INVITE_CLICK=""
              @click="handleClickInvite"
      />
      <ym-img class="million-read-invite-deco-01"
              :src="require('@/assets/img/million_read/invite/deco_01.png')"
      />
      <ym-img class="million-read-invite-deco-02"
              :src="require('@/assets/img/million_read/invite/deco_02.png')"
      />
      <ym-img class="million-read-invite-deco-03"
              :src="require('@/assets/img/million_read/invite/deco_03.png')"
      />
      <ym-img class="million-read-invite-deco-04"
              :src="require('@/assets/img/million_read/invite/deco_04.png')"
      />
    </div>
    <div class="million-read-invite-my-coin">
      <ym-img class="million-read-invite-my-coin-bg"
              :src="require('@/assets/img/million_read/invite/coin_bg.png')"
      />
      <ym-img class="million-read-invite-my-coin-invite-btn"
              :src="require('@/assets/img/million_read/invite/invite.png')"
              @click="handleMyCoinDetail"
              v-ym-report:COIN_INVITE_DETAILS_CLICK=""
      />
      <div class="million-read-invite-my-coin-detail">
        <div class="million-read-invite-my-coin-added-coin">
          {{ coin.totalCoin }}
        </div>
        <div class="million-read-invite-my-coin-total-coin">
          {{ coin.addedCoin }}
        </div>
      </div>
    </div>
    <div class="million-read-invite-exchange-shop">
      <ym-img class="million-read-invite-exchange-shop-block-title"
              :src="require('@/assets/img/million_read/invite/shop_block_title.png')"
      />
      <notice-bar class="million-read-invite-exchange-shop-notice-bar"
                  :list="noticeBar"
                  type="invite"
      />
      <!-- eslint-disable max-len -->
      <div class="million-read-invite-exchange-shop-list">
        <div class="million-read-invite-exchange-shop-list-item"
             v-for="(item, index) in exchangeShop.list"
             :key="index"
             v-ym-report:COIN_INVITE_EXCHANGE_MALL_GOODS_EXPOSURE|COIN_INVITE_EXCHANGE_MALL_GOODS_CLICK="{
               goodsId: item.id,
               index,
             }"
             @click="handleClickItem(item.id)"
        >
          <ym-img class="million-read-invite-exchange-shop-list-item-cover"
                  :src="item.cover"
          />
          <div class="million-read-invite-exchange-shop-list-item-bottom">
            <div class="million-read-invite-exchange-shop-list-item-title ym-line-ellipsis">
              {{ item.title }}
            </div>
            <div class="million-read-invite-exchange-shop-list-item-action">
              <div class="million-read-invite-exchange-shop-list-item-coin">
                <ym-img class="icon"
                        :src="require('@/assets/img/million_read/coin_icon.png')"
                />
                {{ item.coin }}
              </div>
              <div class="million-read-invite-exchange-shop-list-item-exchange-btn"
                   :class="{ 'disabled': item.exchange.status !== 'canExchange' }"
              >
                {{ item.exchange.status !== 'canExchange' ? '即将上线' : '立即兑换' }}
              </div>
            </div>
            <div class="million-read-invite-exchange-shop-list-item-member">
              {{ item.exchange.member }}人已兑换
            </div>
          </div>
        </div>
      </div>
      <div v-if="exchangeShop && exchangeShop.showMore"
           class="million-read-invite-exchange-shop-more-btn"
           v-ym-report:COIN_INVITE_EXCHANGE_MALL_MORE_EXPOSURE|COIN_INVITE_EXCHANGE_MALL_MORE_CLICK=""
           @click="handleShowMore"
      >
        更多礼品
      </div>
      <!-- eslint-disable max-len -->
    </div>
    <div class="million-read-invite-footer">
      <ym-img class="million-read-invite-deco-06"
              :src="require('@/assets/img/million_read/invite/deco_06.png')"
      />
      <ym-img class="million-read-invite-deco-07"
              :src="require('@/assets/img/million_read/invite/deco_07.png')"
      />
      <ym-img class="million-read-invite-footer-slogan"
              :src="require('@/assets/img/million_read/invite/slogan.png')"
      />
      <confirm-popup :show.sync="showUpdatePopup"
                     content="更新最新版少年商学院App<br/>即可邀请好友换好礼"
                     cancel-text="取消"
                     :confirm-text="updatePopupConfirmText"
                     @confirm="handleUpdateApp"
      />
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import NoticeBar from '@/components/ExchangeMallNoticeBar';
  import ConfirmPopup from '@/pages/MillionRead/components/ConfirmPopup';
  import { getInviteInfo } from '@/services/million-read';
  import {
    isAppWebView,
    locationHref,
    isAndroid,
    isIOS, locationPath,
  } from '@/utils';

  export default {
    name: 'MillionReadInvite',
    metaInfo: {},
    components: {
      NoticeBar,
      ConfirmPopup,
    },
    data() {
      return {
        loaded: false,
        coin: null,
        exchangeShop: null,
        noticeBar: [],
        showUpdatePopup: false,
        render: null,
      };
    },
    computed: {
      ...mapGetters([
        'auth',
      ]),
      inAppWebView() {
        return isAppWebView();
      },
      inAndroid() {
        return isAndroid();
      },
      inIOS() {
        return isIOS();
      },
      oiaAppInvitePath() {
        return `https://oia.youthmba.com/download/app?scheme=${this.render.appInvitePath}`;
      },
      isLogin() {
        return Boolean(this.auth && this.auth !== '');
      },
      updatePopupConfirmText() {
        if (this.inAndroid) return '知道了';
        return '马上更新';
      },
    },
    methods: {
      async fetchData() {
        const data = await getInviteInfo();
        this.coin = data.coin;
        this.exchangeShop = data.exchangeShop;
        this.noticeBar = data.noticeBar;
        this.render = data.render;
        this.loaded = true;
      },
      handleRuleDetail() {
        this.$router.push({
          name: 'MillionReadInviteRule',
        });
      },
      handleClickInvite() {
        if (!this.inAppWebView) {
          if (this.inIOS) {
            const scheme = 'scheme=youthmba%3A%2F%2Fbase%2Fweb%3Furl%3Dhttps%3A%2F%2Fm.youthmba.com%2Fmillion%2Fread%2Finvite';
            locationHref(`https://oia.youthmba.com/download/app?${scheme}`);
            return;
          }
          locationHref(this.oiaAppInvitePath);
          return;
        }
        if (!this.render.canInvite) {
          this.showUpdatePopup = true;
          return;
        }
        if (!this.isLogin) {
          locationHref('youthmba://login/login');
          return;
        }
        locationHref(this.oiaAppInvitePath);
      },
      handleUpdateApp() {
        if (this.inAndroid) return;
        locationHref(this.render.appUpdatePath);
      },
      handleMyCoinDetail() {
        locationPath('/exchange/mall/coin?type=invite');
      },
      handleClickItem(id) {
        locationPath(`/exchange/mall/shop/${id}`);
      },
      handleShowMore() {
        locationPath('/exchange/mall');
      },
    },
    created() {
      this.fetchData();
    },
  };
</script>

<style scoped lang="less">
  @import '~@/assets/styles/var.less';

  .million-read-invite {
    min-height: 100%;
    background: #ffd368;

    &-banner-container {
      position: relative;
      width: 750px;
      margin: 0 auto;
    }
    &-rule-btn {
      position: absolute;
      top: 40px;
      right: 0;
      width: 124px;
      height: 52px;
    }

    &-deco-01 {
      position: absolute;
      z-index: 3;
      top: -44px;
      right: 0;
      width: 134px;
      height: 154px;
    }
    &-deco-02 {
      position: absolute;
      z-index: 3;
      top: 84px;
      left: 12px;
      width: 92px;
      height: 92px;
    }
    &-deco-03 {
      position: absolute;
      z-index: 1;
      right: 0;
      bottom: -40px;
      width: 213px;
      height: 296px;
    }
    &-deco-04 {
      position: absolute;
      z-index: 1;
      bottom: -134px;
      left: 0;
      width: 126px;
      height: 154px;
    }
    &-deco-05 {
      position: absolute;
      z-index: -1;
      top: -198px;
      left: 0;
      width: 154px;
      height: 400px;
    }
    &-deco-06 {
      position: absolute;
      bottom: 0;
      left: 0;
      width: 88px;
      height: 108px;
    }
    &-deco-07 {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 126px;
      height: 122px;
    }

    &-join-activity {
      position: relative;
      width: 750px;
      height: 600px;
      margin: -@size-base auto 0;
      &-bg {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 750px;
        height: 600px;
      }
      &-join-btn {
        position: absolute;
        z-index: 3;
        top: 396px;
        left: 82px;
        width: 584px;
      }
    }
    &-my-coin {
      position: relative;
      z-index: 2;
      margin: @size-extra-medium auto 0;
      width: 750px;
      height: 543px;
      background: #ffd368;
      &-invite-btn {
        position: absolute;
        z-index: 3;
        top: 74px;
        right: 26px;
        width: 150px;
        height: 78px;
      }
      &-bg {
        position: absolute;
        z-index: 2;
        top: 0;
        left: 0;
        width: 750px;
        height: 543px;
      }
      &-detail {
        position: absolute;
        z-index: 3;
        top: 312px;
        left: 64px;
        width: 622px;
        display: flex;
        justify-content: space-between;
      }
      &-added-coin,
      &-total-coin {
        width: 312px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: @color-white;
        font-size: 72px;
        font-weight: @font-weight-bold;
        line-height: 1.1;
      }
    }
    &-exchange-shop {
      position: relative;
      z-index: 2;
      width: 674px;
      margin: 82px auto;
      padding: 86px 0 96px 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      background: @color-white;
      box-shadow: 2px 6px 16px 0 rgba(245, 190, 55, 0.25);
      border-radius: 15px;
      &-block-title {
        position: absolute;
        top: -33px;
        right: 0;
        left: 0;
        margin: auto;
        width: 464px;
        height: 98px;
      }
      &-notice-bar {
        margin: 0;
      }
      &-list {
        box-sizing: border-box;
        margin: 52px auto 40px;
        padding-left: @size-small;
        display: flex;
        flex-wrap: wrap;
      }
      &-list-item {
        width: 306px;
        height: 414px;
        margin-bottom: 36px;
        background: @color-white;
        box-shadow: 2px 6px 27px 0 rgba(220, 220, 220, 0.55);
        border-radius: 5px;
        &:nth-child(n) {
          margin-right: @size-small;
        }
        &-cover {
          width: 100%;
          height: 228px;
        }
        &-bottom {
          box-sizing: border-box;
          padding-left: 12px;
        }
        &-title {
          width: 282px;
          margin-top: @size-small;
          color: @color-text-base;
          font-size: @font-size-medium;
          font-weight: @font-weight-strong;
          line-height: 1;
        }
        &-action {
          width: 282px;
          display: flex;
          margin-top: @size-small;
          align-items: center;
          justify-content: space-between;
          border-radius: 5px;
          overflow: hidden;
        }
        &-coin {
          box-sizing: border-box;
          width: 144px;
          height: 44px;
          padding-left: @size-extra-small;
          display: flex;
          align-items: center;
          color: #e65e4f;
          font-size: @font-size-base;
          font-weight: @font-weight-strong;
          line-height: 1;
          background: #fbefef;
          .icon {
            width: 24px;
            height: 24px;
            margin-right: 12px;
          }
        }
        &-exchange-btn {
          flex: 1;
          height: 44px;
          display: flex;
          align-items: center;
          justify-content: center;
          color: @color-white;
          font-size: @font-size-base;
          font-weight: @font-weight-strong;
          line-height: 1;
          background: #e84630;
          &.disabled {
            font-weight: 400;
            background: @color-text-lighter;
          }
        }
        &-member {
          margin-top: @size-small;
          color: @color-text-light;
          font-size: @font-size-extra-small;
          line-height: 1;
        }
      }
      &-more-btn {
        width: 584px;
        height: 88px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: #dc7836;
        font-size: 42px;
        font-weight: @font-weight-strong;
        line-height: 1.2;
        border: 1px solid #dc7836;
        border-radius: 44px;
      }
    }
    &-footer {
      box-sizing: border-box;
      position: relative;
      width: 750px;
      margin: 74px auto 0;
      padding-bottom: 94px;
      display: flex;
      justify-content: center;
      &-slogan {
        width: 434px;
        height: 40px;
      }
    }
  }

</style>
